import { Component, Host, h, Element, State, Prop } from '@stencil/core';
import { gettrackmeEventCategory, gettrackmeEventObject } from '../../../utils/tracking-helpers';
import { E_SEW_SEARCH_FIELD_SIZE } from '../../forms/sew-search-field/sew-search-field.types';

@Component({
    tag: 'sew-ws-services-contact',
    styleUrl: 'sew-ws-services-contact.scss',
    shadow: true,
})
export class SewWsServicesContact {
    @Element() host: HTMLSewWsServicesContactElement;

    @Prop() apiUrl = 'https://www.sew-d.de/api/v1/zipcode/DE?search=';
    @Prop() phonePrefixLabel = 'Tel.';
    @Prop() placeholder: string;
    @Prop() buttonText: string;
    @Prop() helpText: string;
    @Prop() errorMessage: string;
    @Prop() servicesItemLabel: string;
    @Prop() externalZipcodeSearch: string;
    @Prop() externalZipcodeInputName: string;

    @State() value = '';
    @State() address: { name: string; email: string; telephone: string };
    @State() addressElementWidth = '0';
    @State() hasResult: boolean;
    @State() searchTerm: string;

    private addressElement: HTMLElement;
    private formElement: HTMLFormElement;

    private search = () => {
        const options = {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        };

        fetch(this.apiUrl + this.value, options)
            .then(response => response.json())
            .then(json => {
                this.hasResult = json.result_available;
                this.address = json.result;
                this.searchTerm = json.search;
            });
    };

    private onSearchTermChange = (e: Event) => {
        const target = e.target as HTMLInputElement;
        this.value = target.value;
        !(this.externalZipcodeSearch?.length > 0) && this.search();
    };

    private convertText = (text: string): string => {
        const convertedText = text.replace('%1', this.searchTerm);

        return convertedText;
    };

    private submitForm = () => {
        this.externalZipcodeSearch?.length > 0 && this.formElement.submit();
    };

    componentDidRender(): void {
        this.addressElementWidth = this.hasResult ? this.addressElement.offsetWidth + 'px' : '1px';
    }

    render() {
        return (
            <Host>
                <div class="content-wrapper" style={{ '--min-width': this.addressElementWidth }}>
                    <div class="search-area">
                        {this.externalZipcodeSearch?.length > 0 ? (
                            <form
                                ref={el => (this.formElement = el)}
                                action={this.externalZipcodeSearch}
                                id="fr_contact_form"
                            >
                                <sew-search-field ws size={E_SEW_SEARCH_FIELD_SIZE.XS}>
                                    <input
                                        placeholder={this.placeholder}
                                        onChange={this.onSearchTermChange}
                                        value={this.value}
                                        name={this.externalZipcodeInputName}
                                    />
                                </sew-search-field>
                            </form>
                        ) : (
                            <sew-search-field ws size={E_SEW_SEARCH_FIELD_SIZE.XS}>
                                <input
                                    placeholder={this.placeholder}
                                    onChange={this.onSearchTermChange}
                                    value={this.value}
                                />
                            </sew-search-field>
                        )}

                        <sew-ws-button>
                            <button
                                data-sew-trackme-event-category={gettrackmeEventCategory('Services')}
                                data-sew-trackme-event-object={gettrackmeEventObject(
                                    `Services_${this.servicesItemLabel}_${this.placeholder}`
                                )}
                                data-sew-trackme-event-action={`Click_${this.value}`}
                                onClick={this.submitForm}
                            >
                                {this.buttonText}
                            </button>
                        </sew-ws-button>
                    </div>

                    {!(this.externalZipcodeSearch?.length > 0) && (
                        <address class="address-area" ref={el => (this.addressElement = el as HTMLElement)}>
                            {this.hasResult && this.address?.name && <div>{this.address?.name}</div>}
                            {this.hasResult && this.address?.telephone && (
                                <div>{this.phonePrefixLabel + ': ' + this.address?.telephone}</div>
                            )}
                            {this.hasResult && this.address?.email && <div>{this.address?.email}</div>}
                            {this.hasResult === false && (
                                <p class="error-message" innerHTML={this.convertText(this.errorMessage)} />
                            )}
                        </address>
                    )}

                    <div class="links-area">
                        <slot name="links" />
                    </div>
                </div>
            </Host>
        );
    }
}
